import {SActionBtn, SFuncModal, SFuncModalFormRef, SLowcodeList, STableActions,} from 'shj-components'
import {useRef, useState} from 'react'
import config from './config'
import {categoryBatchUpdateStatus, getChannelCategoryTree,} from '@/services/channelManagement'
import AddOrEdit from './addOrEdit'
import {cloneDeep} from 'lodash-es'
import KeepAlive from 'react-activation'
import {getAuth} from 'shj-utils'
import {authDict} from "shj-utils/dist/esm/utils";

const ChannelClassList = () => {
  const config_ = cloneDeep(config)
  const listRef = useRef<any>()
  const editRef = useRef<SFuncModalFormRef>({onReset: undefined, onFinish: undefined})
  const [treeData, setTreeData] = useState<any>([]);
  const [channelCategoryData, setChannelCategoryData] = useState<any>([]);
  const [channelCategoryRecord, setChannelCategoryRecord] = useState<any>(undefined);


  const formatData = (data: any) => {
    return data?.map((item: any) => {
      if (item?.children && item?.children.length > 0) {
        item.children = formatData(item?.children);
      }
      const obj = cloneDeep(item?.object)
      delete obj?.id
      return {...item, ...obj};
    });
  };

  const fetchList = ({query}: any) => {
    // return new Promise(resolve => resolve({records: []}))
    return new Promise((resolve, reject) => {
      try {
        getChannelCategoryTree({...query, direction: 'ALL'}).then((res: any) => {
          const tree = formatData(res)
          const data = cloneDeep(tree)
          setTreeData(data)
          resolve({records: tree});
        });
      } catch (e) {
        reject({success: false});
      }
    });
  };

  // 新增
  const onAdd = () => {
    onAddOrEdit({})
  }

  const onAddOrEdit = (record: Record<string, any> = {}) => {
    const list_ = [
      {label: '根节点', value: '0', key: '0', id: '0', title: '根节点', children: []},
    ]
    list_[0].children = cloneDeep(treeData)
    setChannelCategoryData(list_)
    setChannelCategoryRecord(record)
    // SFuncModal({
    //   title: record.id ? '编辑' : '新增',
    //   // reset: true,
    //   // cancel: false,
    //   formRef: editRef.current,
    //   content: (
    //     <ModalAddOrEditDom
    //       formRef={editRef}
    //       channelCategoryData={list_}
    //       record={record}
    //       reload={() => listRef.current?.reload()}
    //     />
    //   ),
    // })
  }

  const batchUpdateStatus = (ids: any[], enabled: boolean) => {
    categoryBatchUpdateStatus(ids, enabled).then(() => {
      listRef.current?.reload();
    })
  }

  const onUnEnabled = () => {
    const [selectedRowKeys] = listRef?.current?.getSelectedRows();
    batchUpdateStatus(selectedRowKeys, false);
  };

  const onEnabled = () => {
    const [selectedRowKeys] = listRef?.current?.getSelectedRows();
    batchUpdateStatus(selectedRowKeys, true);
  };

  const extension = {
    request: {fetchList},
    events: {onAdd, onUnEnabled, onEnabled},
    auth: authDict,
    status: {
      btnDisabled: ({selectedRowKeys}: Record<string, number[]>) => !selectedRowKeys.length,
    },
    customRender: {
      actionTool: (_: undefined, record: Record<string, any>) => {
        return (
          <STableActions>
            <SActionBtn onClick={() => onAddOrEdit(record)}>
              {/*auth="FlowChannelClassificationButton2" */}
              编辑
            </SActionBtn>
          </STableActions>
        )
      },
    },
  }

  return<>
   <AddOrEdit open={!!channelCategoryRecord} record={channelCategoryRecord} channelCategoryData={channelCategoryData} onClose={()=>{setChannelCategoryRecord(undefined)}} reload={() => listRef.current?.reload()}/>
   <SLowcodeList config={config_} ref={listRef} searchMode={"group"} {...extension} />
  </>
}

export default () => {
  return (
    <KeepAlive name={location.pathname} id={'keep' + location.pathname}>
      <ChannelClassList/>
    </KeepAlive>
  )
}
